import React, { useMemo } from 'react';

import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import { Checkbox as BlueprintCheckbox } from '@buildoutinc/blueprint-react/ui/Checkbox';
import { Label } from '@buildoutinc/blueprint-react/ui/Label';

interface Props extends React.ComponentProps<typeof BlueprintCheckbox> {
  label?: React.ReactNode;
}

export function Checkbox({ className, id: idProp, label, ...props }: Props) {
  const id = useMemo(() => idProp || uuid(), [idProp]);

  return (
    <div className={classNames('d-flex align-items-center gap-2', className)}>
      <BlueprintCheckbox id={id} {...props} />
      <Label className="form-check-label" htmlFor={id}>
        {label}
      </Label>
    </div>
  );
}
